import { Button, Stack, Typography } from '@mui/material';
import { useMutation } from '@tanstack/react-query';

import type { ApiError } from '../../@types';
import API_ROUTES from '../../constants/apiRoutes';
import { useModal } from '../../contexts/ModalContext';
import { useToast } from '../../contexts/ToastContext';
import { useToastErrorMessage } from '../../hooks/useToastErrorMessage';
import { postData } from '../../utils/api';
import ConfirmationModal from '../modals/ConfirmationModal';

const RequestFeedSnapshot = ({ disabled }: { disabled: boolean }) => {
  const { openModal, closeModal } = useModal();
  const { enqueueSnackbar } = useToast();
  const { handleErrorMessage } = useToastErrorMessage();
  const requestSnapshotMutation = useMutation<void, ApiError, void>({
    mutationFn: () => {
      return postData(API_ROUTES.BO_TEMPLATES_REQUEST_SNAPSHOT, {}, 'ftbConsumer');
    },
    onSuccess: () => {
      enqueueSnackbar({
        message: 'Snapshot requested successfully.',
        variant: 'success',
      });
    },
    onError: (error) => {
      handleErrorMessage(error);
    },
  });

  const openSnapshotConfirmationModal = () => {
    openModal(
      <ConfirmationModal
        title='Request a snapshot now?'
        actionButtonLabel='Confirm'
        actionButtonClose='Cancel'
        handleConfirm={() => requestSnapshotMutation.mutate()}
        closeModal={closeModal}
      />
    );
  };

  return (
    <Stack spacing={2}>
      <Typography variant='h6'>Request Snapshot</Typography>
      <Typography variant='body2' color='text.secondary'>
        Trigger a fresh Feed The Bet snapshot request when you need the platform to reload current feed state.
      </Typography>
      <Button
        variant='contained'
        onClick={openSnapshotConfirmationModal}
        disabled={disabled || requestSnapshotMutation.isPending}
        sx={{ alignSelf: 'flex-start' }}
      >
        Request
      </Button>
    </Stack>
  );
};

export default RequestFeedSnapshot;
